/* Progressive table of contents only. Never fetch or rewrite policy wording. */
(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-campaign-policy]').forEach(page => {
      const body = page.querySelector('[data-policy-body]');
      const nav = page.querySelector('[data-policy-toc]');
      if (!body || !nav || page.dataset.policyInitialized === 'true') return;
      const contents = page.querySelector('[data-policy-contents]');
      if (contents && typeof matchMedia === 'function' && matchMedia('(max-width: 749px)').matches) contents.open = false;
      const headings = [...body.querySelectorAll('h2')].filter(heading => heading.textContent.trim());
      if (!headings.length) return;
      const fragment = document.createDocumentFragment();
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = `${body.id}-heading-${index + 1}`;
        const link = document.createElement('a');
        link.setAttribute('href', `#${heading.id}`);
        link.textContent = heading.textContent.trim();
        fragment.append(link);
      });
      nav.replaceChildren(fragment);
      page.dataset.policyInitialized = 'true';
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
